export default __webpack_public_path__ + "static/media/bgbanner.8ada8968.jpg";